export enum NAVIGATION_MENU_LIST {
  TRAINING = 'TRAINING',
  ASSETS = 'ASSETS',
  CALL_AI = 'CALL_AI',
  DSR = 'DSR',
  CONTENT_CENTER = 'CONTENT_CENTER',
  ANALYTICS = 'ANALYTICS',
  USERS = 'USERS',
  ACCOUNT_SETTINGS = 'ACCOUNT_SETTINGS',
}

export enum TRAINING_SUB_MENU_LIST {
  TRAINING_OVERVIEW = 'TRAINING_OVERVIEW',
  TRAINING_SERIES = 'TRAINING_SERIES',
  TRAINING_MODULES = 'TRAINING_MODULES',
  TRAINING_ILT = 'TRAINING_ILT',
  TRAINING_SERIES_OVERVIEW = 'TRAINING_SERIES_OVERVIEW',
  TRAINING_CERTIFICATIONS = 'TRAINING_CERTIFICATIONS',
  TRAINING_TAGS = 'TRAINING_TAGS',
  TRAINING_MARKETPLACE = 'TRAINING_MARKETPLACE',
}

export enum ASSETS_SUB_MENU_LIST {
  ASSETS_HUBS = 'ASSETS_HUBS',
  ASSETS_ASSETS = 'ASSETS_ASSETS',
  ASSETS_ATTRIBUTES = 'ASSETS_ATTRIBUTES',
  ASSETS_HUBS_OVERVIEW = 'ASSETS_HUBS_OVERVIEW',
}

export enum CALL_AI_SUB_MENU_LIST {
  CALL_AI_LIBRARIES = 'CALL_AI_LIBRARIES',
  CALL_AI_TRAINING_CALLS = 'CALL_AI_TRAINING_CALLS',
}

export enum DSR_SUB_MENU_LIST {
  DSR_ROOMS = 'DSR_ROOMS',
  DSR_TEMPLATES = 'DSR_TEMPLATES',
  DSR_INSIGHTS = 'DSR_INSIGHTS',
  DSR_DEALS = 'DSR_DEALS',
  DSR_SETTINGS = 'DSR_SETTINGS',
}

export enum ANALYTICS_SUB_MENU_LIST {
  ANALYTICS_MY = 'ANALYTICS_MY',
  ANALYTICS_TRAINING = 'ANALYTICS_TRAINING',
  ANALYTICS_USERS = 'ANALYTICS_USERS',
  ANALYTICS_ASSETS = 'ANALYTICS_ASSETS',
  ANALYTICS_CALL_AI = 'ANALYTICS_CALL_AI',
  ANALYTICS_COACHING = 'ANALYTICS_COACHING',
  ANALYTICS_RI = 'ANALYTICS_RI',
}

export enum USERS_SUB_MENU_LIST {
  USERS_USERS = 'USERS_USERS',
  USERS_GROUPS = 'USERS_GROUPS',
  USERS_PROFILE = 'USERS_PROFILE',
  USERS_ROLES = 'USERS_ROLES',
}

export enum ACCOUNT_SUB_MENU_LIST {
  ACCOUNT_SETTINGS_HOMEPAGES = 'ACCOUNT_SETTINGS_HOMEPAGES',
  ACCOUNT_SETTINGS_EMAIL = 'ACCOUNT_SETTINGS_EMAIL',
  ACCOUNT_SETTINGS_AUTO_SUITE = 'ACCOUNT_SETTINGS_AUTO_SUITE',
  ACCOUNT_SETTINGS_INTEGRATIONS = 'ACCOUNT_SETTINGS_INTEGRATIONS',
  ACCOUNT_SETTINGS_CUSTOM_PROPERTIES = 'ACCOUNT_SETTINGS_CUSTOM_PROPERTIES',
  ACCOUNT_SETTINGS_LOGS = 'ACCOUNT_SETTINGS_LOGS',
  ACCOUNT_SETTINGS_SETTINGS = 'ACCOUNT_SETTINGS_SETTINGS',
}
